import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from '@welldev-group/rcl-popover';
import IconButton from '@welldev-group/rcl-icon-button';
import { I18nText, Link } from '@welldev-group/react-comp-lib';
import Icon from '@welldev-group/rcl-icon';

const ShowMore = ({ options, closePopover }) => {
  const [isVisible, setIsVisible] = useState(false);

  const list = [];
  options.forEach(option => {
    let { item, key } = option;
    if (!item) {
      key = option.link;
      item = (
        <Link
          modifier="default"
          className="show-more__content"
          href={option.link}
        >
          {option.label}
        </Link>
      );
    }

    list.push(
      <li key={key} className="show-more__item">
        {item}
      </li>,
    );
  });

  useEffect(() => {
    if (closePopover) {
      setIsVisible(false);
    }
  }, [closePopover]);
  return (
    <div className="show-more">
      <Popover
        className="settings__sections-header-locale-wrapper-popover"
        isVisible={isVisible}
        onOutsideClick={() => setIsVisible(false)}
        content={<ul className="show-more__list">{list}</ul>}
        size="small"
        direction="bottom-right"
      >
        <IconButton
          icon={<Icon name="horizontalDots" size="normal" />}
          onClick={() => {
            setIsVisible(previousIsVisibleState => !previousIsVisibleState);
          }}
          label={<I18nText id="show_more.more" />}
        />
      </Popover>
    </div>
  );
};

ShowMore.defaultProps = {
  closePopover: false,
};

ShowMore.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      label: PropTypes.node,
      key: PropTypes.string,
      item: PropTypes.node,
    }),
  ).isRequired,
  closePopover: PropTypes.bool,
};

export default ShowMore;
